import React, { useEffect, useMemo, useRef, useState } from 'react';
import {
  Box,
  Grid,
  Button,
  Typography,
  Tooltip,
  CircularProgress,
  IconButton,
  Menu,
  MenuItem,
  FormControl,
  Input
} from '@mui/material';
import { ListItemText } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert'; // Icon for the dropdown button
import { Row, Col, Form, Card } from 'react-bootstrap';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import { MaterialReactTable, MRT_ColumnDef } from 'material-react-table';
import { alertAtom, orderFiltersAtom, orderListObjAtom, selectedOrderAtom, orderStatusAtom, paymentStatusListAtom, userDetailAtom } from '../../../Services/_states/index.js';
import { dateFormate, indianTimeZone } from '../../../utils/helper.jsx';
import { ECommerceActions } from '../../../Services/_actions/ECommerce/ecommerce.action.js';
import { ConstantActions } from '../../../Services/_actions/index.js';
import SweetAlert from '../../Shared/Notification/index.jsx';
import Invoice, { generateInvoicePDF } from './invoice.jsx';
import SelectDropdown from '../../Shared/SelectDropdown/index.jsx';
import { GetStatusBadges } from '../../InterveneDashboard/Constant/GetStatusBadges.jsx';
import CommonTable from '../../Shared/Tables/TableV1.tsx';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import Pagination from '../../FlowBuilder/Common/Pagination/index.tsx';
import SearchableDropdown from "../../FlowBuilder/Common/SearchableDropdown/SearchableDropdown.tsx";
import SearchBox from '../../FlowBuilder/Common/SearchBox/index.tsx';
import DownloadIcon from '@mui/icons-material/Download';
import UploadIcon from '@mui/icons-material/Upload';
import SummaryCards from './SummaryCard.tsx';
import OrderDetails from './orderDetails.tsx';
import { useSnackBar } from '../../FlowBuilder/Common/SnackBar/index.tsx';
import useDebounce from '../../Shared/Delay/index.tsx';
import ConfirmBox from '../../FlowBuilder/Common/ConfirmBox/index.tsx';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { TextField } from '@mui/material';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import dayjs, { Dayjs } from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import BotNumberDropdown from '../../Shared/BotNumberDropdown/index.tsx';
import OrganisationDropdown from '../../Shared/OrganisationDropdown/index.tsx';
import { userInformationAtom } from '../../../Services/_states/index.js';

const OrderList = () => {
  const actions = ECommerceActions();
  const constantActions = ConstantActions();
  const [selectedFile, setSelectedFile] = useState(null)
  const [selectedOrder, setSelectedOrder] = useRecoilState(selectedOrderAtom);
  const [orderListObj, setOrderListObj] = useRecoilState(orderListObjAtom);
  const [orderFilters, setOrderFilters] = useRecoilState(orderFiltersAtom);
  const [orderStatusList, setOrderStatusList] = useRecoilState(orderStatusAtom);
  const [paymentStatusList, setPaymentStatusList] = useRecoilState(paymentStatusListAtom);
  const isLoading = useRecoilValue(alertAtom);
  const [selectedIds, setSelectedIds] = useState<string[]>([]);
  const [selectedStatus, setSelectedStatus] = useState<string | null>(null);
  const [selectedOption, setSelectedOption] = useState<string | null>(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const uploadDocumentsRef1: any = useRef(null);
  const [rowSelection, setRowSelection] = useState({});
  const { showSnackBar } = useSnackBar();
  const [isConfirmOpen, setIsConfirmOpen] = useState(false);
  const [confirmTitle, setConfirmTitle] = useState('');
  const [confirmText, setConfirmText] = useState('');
  const [onConfirmAction, setOnConfirmAction] = useState<(() => void) | null>(null);
  const [showDenyButton, setShowDenyButton] = useState(false);
  const loggedInUser = useRecoilValue(userInformationAtom);


  const fetchOrderList = async (data = {}) => {
    const mergedFilters = { ...orderFilters, ...data };
    const payload = {
      ...mergedFilters,
      organisation: mergedFilters?.organisationObj?.organisation_id || '',
      botNumber: mergedFilters?.channelObj?.wa_phone_number || '',
    };
    console.log("🚀 Final OrderList Payload:", mergedFilters);
    await actions.getOrderList(mergedFilters);
  };


  const handleGoClick = async () => {
    if (selectedStatus && selectedOption && selectedIds.length > 0) {
      const data = { order_ids: selectedIds };
      data[selectedStatus] = typeof selectedOption === 'string'
        ? selectedOption.toLowerCase()
        : selectedOption?.value?.toLowerCase?.() || selectedOption?.status_name?.toLowerCase?.();

      setConfirmTitle(`Update ${selectedStatus === 'payment_status' ? 'Payment' : 'Delivery'} Status`);
      setConfirmText(`Are you sure you want to update the selected ${selectedIds.length} orders?`);
      setShowDenyButton(true);

      setOnConfirmAction(() => async (isAlt = false) => {
        if (isAlt) {
          data['is_template_send'] = true;
        }

        const res = await actions.updateOrderPaymentStatus(data);
        if (res?.status) {
          SweetAlert(res?.data, "success");
          setOrderListObj(prevOrderListObj => {
            const updatedList = prevOrderListObj?.list?.map((row) => {
              if (selectedIds.includes(row.company_order_id)) {
                return {
                  ...row,
                  [selectedStatus]: typeof selectedOption === 'string'
                    ? selectedOption.toLowerCase()
                    : selectedOption?.value?.toLowerCase?.() || selectedOption?.status_name?.toLowerCase?.()
                };
              }
              return row;
            });

            return {
              ...prevOrderListObj,
              list: updatedList,
            };
          });

          // Clear selection and status
          setSelectedIds([]);
          setSelectedStatus(null);
          setSelectedOption(null);
          setRowSelection({});
        }
      });

      setIsConfirmOpen(true);
    } else {
      showSnackBar('Please select a status, option, and at least one row to update.', 'warning');
    }
  };

  const exportCSV = async () => {
    await actions.exportOrderData(orderFilters);
    handleClose();
  };

  const handleFileChange = async (e) => {
    if (e && e?.target?.files?.length > 0) {
      handleClose();
      const file = e.target.files[0];
      setSelectedFile(file);

      setConfirmTitle(`Confirm File Upload`);
      setConfirmText(`Are you sure you want to upload this file?`);

      setOnConfirmAction(() => async () => {
        let form = new FormData();
        form.append('file', file);
        await actions.uploadOrderStatus(form);
        if (uploadDocumentsRef1.current) {
          uploadDocumentsRef1.current.value = '';
        }
      });

      setIsConfirmOpen(true);
    }
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const onClickDropdown = async (status, company_order_id) => {
    const selectedStatus = status?.toLowerCase();
    const data = { order_ids: [company_order_id], order_status: selectedStatus };
    const isNowDelivered = selectedStatus === 'delivered';
    setConfirmTitle(`Update Order Status`);
    setConfirmText(`Are you sure you want to change status to "${status}"?`);
    setIsConfirmOpen(true);
    setShowDenyButton(true);
    setOnConfirmAction(() => async (isAlt = false) => {
      if (isAlt) {
        data['is_template_send'] = true;
      }

      const res = await actions.updateOrderPaymentStatus(data);
      if (res?.status) {
        SweetAlert(res?.data, "success");
        setOrderListObj(prevOrderListObj => {
          const updatedList = prevOrderListObj?.list?.map((row) => {
            if (row?.company_order_id === company_order_id) {
              return { ...row, order_status: selectedStatus };
            }
            return { ...row };
          });

          const updatedSummaryCounts = isNowDelivered
            ? {
              ...prevOrderListObj.summary_counts,
              delivered: prevOrderListObj.summary_counts.delivered + 1,
              total_delivery_pending: prevOrderListObj.summary_counts.total_delivery_pending - 1,
            }
            : prevOrderListObj.summary_counts;

          return {
            ...prevOrderListObj,
            list: updatedList,
            summary_counts: updatedSummaryCounts,
          };
        });
      }
    });
  };

  const getStatusIsEnableDisable = (currentStatus, status) => {
    const statusData = status?.toLowerCase();
    currentStatus = currentStatus?.toLowerCase();
    switch (currentStatus) {
      case 'order placed':
        return ['order placed'].includes(statusData);
      case 'order confirmed':
        return ['order placed', 'order confirmed'].includes(statusData);
      case 'cancelled':
        return ['order placed', 'order confirmed', 'cancelled', 'shipped', 'out for delivery', 'failed delivery', 'delivered', 'return request', 'returned'].includes(statusData);
      case 'shipped':
        return ['order placed', 'order confirmed', 'cancelled', 'shipped'].includes(statusData);
      case 'out for delivery':
        return ['order placed', 'order confirmed', 'cancelled', 'shipped', 'out for delivery'].includes(statusData);
      case 'failed delivery':
        return ['order placed', 'order confirmed', 'cancelled', 'shipped', 'out for delivery', 'failed delivery'].includes(statusData);
      case 'delivered':
        return ['order placed', 'order confirmed', 'cancelled', 'shipped', 'out for delivery', 'failed delivery', "delivered"].includes(statusData);
      case 'return requested':
        return ['order placed', 'order confirmed', 'cancelled', 'shipped', 'out for delivery', 'failed delivery', "delivered", 'return requested'].includes(statusData);
      case 'returned':
        return ['order placed', 'order confirmed', 'cancelled', 'shipped', 'out for delivery', 'failed delivery', "delivered", 'return requested'].includes(statusData);

      default: return false;
    }
  }

  const handleRowSelectionChange = (updater) => {
    const newSelection = typeof updater === 'function' ? updater(rowSelection) : updater;
    setRowSelection(newSelection);
  };


  useEffect(() => {
    if (!orderListObj?.list) return;

    const selected = Object.keys(rowSelection)
      .map((index) => orderListObj.list[+index])
      .filter(Boolean)
      .map((row) => row.company_order_id);

    setSelectedIds(selected);
  }, [rowSelection, orderListObj?.list]);


  const fetchStatusList = async () => {
    const orderPayload = { dashboard: "OrderDashboard", category: "OrderStatus" };
    const orderStatus = await constantActions.getMachadaloStatusList(orderPayload);
    setOrderStatusList(orderStatus?.client_status || []);

    const paymentPayload = { dashboard: "OrderDashboard", category: "PaymentStatus" };
    const paymentStatus = await constantActions.getMachadaloStatusList(paymentPayload);
    setPaymentStatusList(paymentStatus?.client_status || []);
  };

  const debouncedSearch = useDebounce(orderFilters.search, 500);

  useEffect(() => {
    fetchOrderList({ ...orderFilters, search: debouncedSearch, page: 0 });
  }, [debouncedSearch]);


  useEffect(() => {
    fetchStatusList();
    // fetchOrderList();
  }, []);

  const columns = useMemo<MRT_ColumnDef<any>[]>(
    () => [
      {
        accessorKey: 'company_order_id',
        header: 'Company Order ID',
        size: 180,
        Cell: ({ row }) => (
          <Typography
            variant="body2"
            sx={{ cursor: 'pointer', color: 'blue' }}
            onClick={() => setSelectedOrder(row.original)}
          >
            {row.original.company_order_id}
          </Typography>
        ),
      },
      {
        accessorKey: 'order_id',
        header: 'Order ID',
        size: 120,
        Cell: ({ row }) => (
          <Typography
            variant="body2"
            sx={{ cursor: 'pointer', color: 'blue' }}
            onClick={() => getOrderDataById(row.original)}
          >
            {row.original.order_id}
          </Typography>
        ),
      },
      {
        accessorKey: 'order_date',
        header: 'Order Date',
        Cell: ({ row }) => (
          dateFormate(indianTimeZone(row.original.order_date), "DD-MM-YYYY hh:mm A")
        ),
      },
      {
        accessorKey: 'expected_delivery_date',
        header: 'Expected Delivery Date',
        size: 200,
        minSize: 200,
        Cell: ({ row }) => {
          const selectedDate = row.original.expected_delivery_date
            ? dayjs(row.original.expected_delivery_date)
            : null;

          const handleInputChange = (e) => {
            const value = e.target.value;
            const newDate = dayjs(value);

            if (value && newDate.isValid()) {
              handleDateChange(newDate, row.original.company_order_id);
            }
          };


          return (
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                label="Expected Delivery Date"
                value={selectedDate}
                onChange={(newDate) => {
                  if (newDate && dayjs(newDate).isValid()) {
                    if (dayjs(newDate).isBefore(dayjs(), 'day')) {
                      showSnackBar("Past date selection is not allowed", 'error');
                      return;
                    }
                    handleDateChange(newDate, row.original.company_order_id);
                  }
                }}
                minDate={dayjs()}
                slotProps={{
                  textField: {
                    size: 'small',
                    sx: { width: '140px' },
                    InputLabelProps: { shrink: true },
                    error: false,
                    helperText: '',
                  },
                }}
                slots={{
                  yearButton: (props) => (
                    <span style={{ pointerEvents: 'none', opacity: 0.5 }}>
                      {props.children}
                    </span>
                  ),
                }}
              />

            </LocalizationProvider>
          );
        },
      },
      {
        accessorKey: 'order_status',
        header: 'Order Status',
        Cell: ({ row }) => {
          const [anchorEl, setAnchorEl] = useState(null);
          const open = Boolean(anchorEl);
          const handleClick = (event) => {
            setAnchorEl(event.currentTarget);
          };
          const handleClose = () => {
            setAnchorEl(null);
          };
          const handleSelect = (status) => {
            onClickDropdown(status, row.original.company_order_id);
            handleClose();
          };

          return (
            <Box display="flex" alignItems="center" justifyContent="space-between" minWidth="200px">
              {GetStatusBadges(row.original.order_status)}
              <IconButton
                onClick={handleClick}
                size="small"
                sx={{ ml: 1 }}
              >
                <MoreVertIcon fontSize="small" />
              </IconButton>
              <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                PaperProps={{
                  style: {
                    maxHeight: 150,
                    overflowY: 'auto',
                    fontSize: '12px',
                  },
                }}
              >
                {orderStatusList?.map((status, index) => {
                  const isDisabled = getStatusIsEnableDisable(row.original.order_status, status?.alais_name);
                  return (
                    <MenuItem
                      key={`${status?.alais_name}-${index}`}
                      disabled={isDisabled}
                      onClick={() => handleSelect(status?.alais_name)}
                    >
                      <ListItemText primary={status?.alais_name} primaryTypographyProps={{ fontSize: '12px' }} />
                    </MenuItem>
                  );
                })}
              </Menu>
            </Box>
          );
        },
      },

      {
        accessorKey: 'total_amount',
        header: 'Amount',
        Cell: ({ cell }) => `₹ ${cell.getValue()}`,
      },
      {
        accessorKey: 'payment_status',
        header: 'Payment Status',
        Cell: ({ row }) => GetStatusBadges(row.original.payment_status),
      },
      {
        accessorKey: 'customer_detail',
        header: 'Customer',
        Cell: ({ row }) => (
          <>
            <Typography fontWeight="bold">{row.original.customer_detail?.name}</Typography>
            <Typography variant="body2">{row.original.customer_detail?.phone_number}</Typography>
          </>
        ),
      },
      {
        accessorKey: 'channel_sales_partner_detail',
        header: 'CSP',
        Cell: ({ row }) => (
          <>
            <Typography fontWeight="bold">{row.original.channel_sales_partner_detail?.name}</Typography>
            <Typography variant="body2">{row.original.channel_sales_partner_detail?.phone_number}</Typography>
          </>
        ),
      },
      {
        accessorKey: 'company_name',
        header: 'Company',
      },
      {
        accessorKey: 'shipping_address.city',
        header: 'City',
      },
      // {
      //   accessorKey: 'action',
      //   header: 'Action',
      //   size:70,
      //   enableSorting: false,
      //   Cell: ({ row }) => (
      //     <BlobProvider document={<Invoice data={row.original} />}>
      //       {({ loading, url }) =>
      //         !loading ? (
      //           <IconButton onClick={() => window.open(url, '_blank')} size="small">
      //             <PictureAsPdfIcon />
      //           </IconButton>
      //         ) : (
      //           <CircularProgress size={16} />
      //         )
      //       }
      //     </BlobProvider>
      //   ),
      // },
      {
        accessorKey: 'action',
        header: 'Action',
        size: 70,
        enableSorting: false,
        Cell: ({ row }) => (
          <IconButton
            size="small"
            onClick={async () => {
              const doc = await generateInvoicePDF(row.original);
              doc.save(`invoice_${row.original.company_order_id || 'order'}.pdf`);
            }}
          >
            <PictureAsPdfIcon />
          </IconButton>
        ),
      },
    ],
    [orderStatusList]
  );

  const getOrderDataById = async (row) => {
    if (!row?.order_id) return SweetAlert("Order id not found", "warning");
    const res = await actions.getOrderDataById(row.order_id);
    if (res?.data?.length > 0) {
      const mergedObject = res.data.reduce((acc, obj) => {
        acc.products = [...(acc.products || []), ...obj.products];
        Object.entries(obj).forEach(([key, value]) => {
          if (key !== 'products' && acc[key] === undefined) {
            acc[key] = value;
          }
        });
        return acc;
      }, {});
      setSelectedOrder(mergedObject);
    }
  };
  const handleDateChange = async (date, company_order_id) => {
    setConfirmTitle('Update Order Date');
    setConfirmText('Are you sure you want to update the date?');
    setIsConfirmOpen(true);
    setShowDenyButton(false);

    setOnConfirmAction(() => async () => {
      const payload = {
        order_ids: [company_order_id],
        expected_delivery_date: dateFormate(date, 'YYYY-MM-DD'),
      };

      const res = await actions.updateOrderPaymentStatus(payload);
      if (res?.status) {
        SweetAlert(res.data, 'success');
        setOrderListObj(prevOrderListObj => {
          const updatedList = prevOrderListObj?.list?.map((row) => {
            if (row.company_order_id === company_order_id) {
              return {
                ...row,
                expected_delivery_date: date,
              };
            }
            return row;
          });

          return {
            ...prevOrderListObj,
            list: updatedList,
          };
        });
      }
    });
  };

  const handleChangePage = (e, newPage) => {
    setOrderFilters({ ...orderFilters, page: newPage });
    fetchOrderList({ page: newPage });
  };

  const handleChangeRowsPerPage = (e) => {
    const limit = e.target.value;
    setOrderFilters({ ...orderFilters, limit });
    fetchOrderList({ limit, page: 0 });
  };

  const onSearch = (value) => {
    setOrderFilters({ ...orderFilters, search: value, page: 0 });
  };
  return (
    <Box>
      {selectedOrder && Object.keys(selectedOrder).length > 0 ? (
        <OrderDetails />
      ) : (
        <>
          <SummaryCards orderListObj={orderListObj} />
          <Box className="search-box-style" sx={{
            pt: 2, pb: 2, display: 'flex', flexDirection: {
              lg: 'row',
              md: 'column',
              xs: 'column',
            },
            justifyContent: {
              lg: 'space-between',
              md: 'space-between',
              sm: 'space-between',
            },

            alignItems: { xs: "flex-start", sm: "flex-start", xl: 'center' },
            gap: { xs: 3, sm: 2 },
          }}>

            <Box sx={{
              display: 'flex', width: { lg: 'auto', md: '100%' }, gap: { xl: 2, lg: 2, sm: 1, xs: 2 },
              flexDirection: {
                lg: 'row',
                sm: 'row',
                xs: 'column',
              },
              justifyContent: {
                lg: 'space-between',
                sm: 'space-between',
                xs: 'space-between',
              },
              alignItems: {
                lg: 'center',
                sm: 'flex-start',
                xs: 'center'
              },
            }}>
              <SearchableDropdown
                options={[
                  { label: 'Update Payment Status', value: 'payment_status' },
                  { label: 'Update Delivery Status', value: 'order_status' },
                ]}
                value={
                  selectedStatus
                    ? {
                      label:
                        selectedStatus === 'payment_status'
                          ? 'Update Payment Status'
                          : 'Update Delivery Status',
                      value: selectedStatus,
                    }
                    : null
                }
                className="status-dropdown-style"
                sx={{
                  minWidth: '140px',
                  '& .MuiInputBase-root': {
                    height: '29px',
                  },
                }}
                label="Select Status"
                onChange={(e) => setSelectedStatus(e?.value)}
              />

              {selectedStatus && (
                <SearchableDropdown
                  options={selectedStatus === 'payment_status' ? paymentStatusList : orderStatusList}
                  label={
                    selectedStatus === 'payment_status'
                      ? 'Select Payment Option'
                      : 'Select Delivery Option'
                  }
                  value={selectedOption}
                  // sx={{ minWidth: 140 }}
                  className="status-dropdown-style"
                  sx={{
                    minWidth: '140px',
                    '& .MuiInputBase-root': {
                      height: '29px',
                    },
                  }}
                  labelKey="status_name"
                  valueKey="status_name"
                  onChange={(option) => setSelectedOption(option)}
                />

              )}
              {selectedStatus && selectedOption && (
                <Button variant="outlined" size='small' onClick={handleGoClick}>
                  Go
                </Button>
              )}
            </Box>
            {/* <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <SearchBox handleSearch={onSearch} value={orderFilters.search || ''} />
              <IconButton onClick={handleClick}>
                <MoreVertIcon />
              </IconButton>
              <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
                <MenuItem
                  onClick={() => {
                    exportCSV();
                  }}
                >
                  <DownloadIcon sx={{ marginRight: 1 }} />
                  <Typography variant="body2">Download Order</Typography>
                </MenuItem>
                <MenuItem onClick={() => uploadDocumentsRef1.current.click()}>
                  <UploadIcon sx={{ marginRight: 1 }} />
                  <Typography variant="body2">Upload Delivery</Typography>
                  <input
                    type="file"
                    accept=".xlsx, .csv"
                    multiple
                    hidden
                    ref={uploadDocumentsRef1}
                    onChange={handleFileChange}
                  />
                </MenuItem>
              </Menu>
            </Box> */}
            <Box sx={{
              display: 'flex', width: { lg: 'auto', md: '100%' }, gap: { xl: 2, lg: 2, sm: 1, xs: 2 },
              flexDirection: {
                sm: 'row',
                xs: 'column'
              },
              flexFlow: { xs: 'wrap', sm: 'nowrap', md: 'nowrap' },
              justifyContent: {
                lg: 'flex-start',
                md: 'space-between',
              },
              alignItems: {
                md: 'center',
              },
            }} className="input-filed-style"

            >
              <Box>
                <SearchBox handleSearch={onSearch} value={orderFilters.search || ''} />
              </Box>

              {loggedInUser?.is_superuser && (
                <OrganisationDropdown
                  // sx={{ minWidth: 170 }}
                  className="status-dropdown-style"
                  sx={{
                    minWidth: '170px',
                    '& .MuiInputBase-root': {
                      height: '29px',
                    },
                  }}
                  value={orderFilters?.organisationObj || null}
                  onChange={(selected) => {
                    const newFilters = {
                      ...orderFilters,
                      organisationObj: selected,
                      organisation: selected?.organisation_id || '',
                      channelObj: null, // Reset channel on org change
                      botNumber: '',
                      page: 0,
                    };
                    setOrderFilters(newFilters);
                    fetchOrderList(newFilters);
                  }}
                  label="Select Organisation"
                />
              )}

              <BotNumberDropdown
                // sx={{ minWidth: 160 }}
                className="status-dropdown-style"
                sx={{
                  minWidth: '160px',
                  '& .MuiInputBase-root': {
                    height: '29px',
                  },
                }}
                organisation={
                  loggedInUser?.is_superuser
                    ? orderFilters?.organisationObj
                    : loggedInUser?.profile?.organisation || null
                }
                onChange={(selected) => {
                  const newFilters = {
                    ...orderFilters,
                    channelObj: selected,
                    botNumber: selected?.wa_phone_number || '',
                    page: 0,
                  };
                  setOrderFilters(newFilters);
                  fetchOrderList(newFilters);
                }}
                label="Select Bot Number"
              />

              <IconButton onClick={handleClick} sx={{ padding: { xs: '8px', sm: '0px', lg: '8px' } }}>
                <MoreVertIcon />
              </IconButton>
              <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
                <MenuItem
                  onClick={() => {
                    exportCSV();
                  }}
                >
                  <DownloadIcon sx={{ marginRight: 1 }} />
                  <Typography variant="body2">Download Order</Typography>
                </MenuItem>
                <MenuItem onClick={() => uploadDocumentsRef1.current.click()}>
                  <UploadIcon sx={{ marginRight: 1 }} />
                  <Typography variant="body2">Upload Delivery</Typography>
                  <input
                    type="file"
                    accept=".xlsx, .csv"
                    multiple
                    hidden
                    ref={uploadDocumentsRef1}
                    onChange={handleFileChange}
                  />
                </MenuItem>
              </Menu>
            </Box>

          </Box>
          <CommonTable
            columns={columns}
            data={orderListObj?.list || []}
            enableRowSelection={true}
            onRowSelectionChange={handleRowSelectionChange}
            muiTableContainerProps={{ sx: { maxHeight: 'calc(100vh - 323px)', width: '100%' } }}
            state={{
              showColumnFilters: false,
              isLoading,
              rowSelection
            }}
            renderBottomToolbar={() => (
              <Box sx={{ display: 'flex', justifyContent: 'flex-end', padding: 0, margin: 0 }}>
                <Pagination
                  totalCount={orderListObj?.count || 0}
                  rowsPerPage={orderFilters?.limit || 10}
                  page={orderFilters?.page || 0}
                  handleChangePage={handleChangePage}
                  handleChangeRowsPerPage={handleChangeRowsPerPage}
                />
              </Box>
            )}
          />

        </>
      )}
      <ConfirmBox
        open={isConfirmOpen}
        onClose={(confirmed) => {
          setIsConfirmOpen(false);
          if (confirmed?.isDenied) {
            if (onConfirmAction) {
              const altAction = async () => {
                await onConfirmAction(true);
                setOnConfirmAction(null);
              };
              altAction();
            }
          }
          else if (confirmed?.isConfirmed || confirmed === true) {
            if (onConfirmAction) {
              onConfirmAction();
              setOnConfirmAction(null);
            }
          }
        }}
        options={{
          title: confirmTitle,
          text: confirmText,
          confirmButtonText: 'Yes, update it!',
          cancelButtonText: 'Cancel',
          confirmButtonColor: 'error',
          cancelButtonColor: 'default',
          showDenyButton: showDenyButton,
          denyButtonText: 'Update with Send Template',
        }}
      />
    </Box>
  );
};

export default OrderList;
